<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null && designations!==null && branches !==null && cities !== null && departments !== null && managers !== null">
            <div class="modal fade" id="branchModal" tabindex="-1" role="dialog" aria-labelledby="branchLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <form @submit.prevent="addBranch">
                                <div class="clearfix popup-head mb-4">
                                    <h2 class="mt-2 float-left">Add Branch</h2>
                                    <button :disabled="branchForm.busy" class="btn btn-primary float-right submit_form">
                                        Save & Update
                                    </button>
                                    <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                                </div>
                                <div class="form-group">
                                    <label for class="label block-label">Branch Name</label>
                                    <input type="text" class="form-control" name="name" v-model="branchForm.name" :class="{ 'is-invalid': branchForm.errors.has('name') }" autocomplete="off"/>
                                    <has-error :form="branchForm" field="name"></has-error>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="departmentModal" tabindex="-1" role="dialog" aria-labelledby="departmentLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <form @submit.prevent="addDepartment">
                                <div class="clearfix popup-head mb-4">
                                    <h2 class="mt-2 float-left">Add Department</h2>
                                    <button :disabled="departmentForm.busy" class="btn btn-primary float-right submit_form">
                                        Save & Update
                                    </button>
                                    <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                                </div>
                                <div class="form-group">
                                    <label for class="label block-label">Department Name</label>
                                    <input type="text" class="form-control" name="name" v-model="departmentForm.name" :class="{ 'is-invalid': departmentForm.errors.has('name') }" autocomplete="off"/>
                                    <has-error :form="departmentForm" field="name"></has-error>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="designationModal" tabindex="-1" role="dialog" aria-labelledby="designationLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <form @submit.prevent="addDesignation">
                                <div class="clearfix popup-head mb-4">
                                    <h2 class="mt-2 float-left">Add Designation</h2>
                                    <button :disabled="designationForm.busy" class="btn btn-primary float-right submit_form">
                                        Save & Update
                                    </button>
                                    <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                                </div>
                                <div class="form-group">
                                    <label for class="label block-label">Designation Name</label>
                                    <input type="text" class="form-control" name="name" v-model="designationForm.name" :class="{ 'is-invalid': designationForm.errors.has('name') }" autocomplete="off"/>
                                    <has-error :form="designationForm" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label">Departments</label>
                                    <select v-model="designationForm.department_id" data-live-search="true" name="department_id" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': designationForm.errors.has('department_id') }">
                                        <option value="">Select Department</option>
                                        <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">{{ department.name }}</option>
                                    </select>
                                    <has-error :form="designationForm" field="department_id"></has-error>
                                </div>
                                <!-- <div class="form-group">
                                    <label class="label block-label"> Default Designations </label>
                                    <select v-model="designationForm.defaultDesignations_id" data-live-search="true" name="defaultDesignations_id" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('defaultDesignations_id') }" >
                                        <option value="" selected>Select Default Designations</option>
                                        <option v-for="defaultDesignation in defaultDesignations" v-bind:value="defaultDesignation.id" v-bind:key="defaultDesignation.id">
                                            {{ defaultDesignation.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="defaultDesignations_id"></has-error>
                                </div> -->
                                <div class="form-group">
                                    <label class="label block-label">Designation Description</label>
                                    <input v-model="designationForm.designation_description" type="text" name="designation_description" class="form-control" :class="{ 'is-invalid': designationForm.errors.has('designation_description') }">
                                    <has-error :form="designationForm" field="designation_description"></has-error>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <form id="employeeForm" @submit.prevent="addEmployeeBasicDetail">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Employee Email <em class="required">*</em> </label>
                                    <input v-model="form.email" type="email" name="email" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Gross Salary  <em class="required">*</em> </label>
                                    <input v-model="form.gross_salary" type="text" @keypress="isNumber($event)" name="gross_salary" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('gross_salary') }">
                                    <has-error :form="form" field="gross_salary"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Hiring Date <em class="required">*</em> </label>
                                    <datepicker name="hire_date" v-model="form.hire_date" autocomplete="off" input-class="datepicker" :class="{ 'is-invalid': form.errors.has('hire_date') }" :bootstrap-styling="true"></datepicker>
                                    <has-error :form="form" field="hire_date"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Employee Type <em class="required">*</em> </label>
                                    <select v-model="form.employee_type" name="employee_type" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('employee_type') }">
                                        <option value="" selected>Select Employee Type</option>
                                        <option value="PERMANENT">Permanent</option>
                                        <option value="CONTRACTUAL">Contractual</option>
                                        <option value="PROBATION">Probation</option>
                                        <option value="INTERN">Intern</option>
                                        <option value="PIECE_RATE">Piece Rate</option>
                                    </select>
                                    <has-error :form="form" field="employee_type"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Employee Code </label>
                                    <input v-model="form.employee_code" type="text" name="employee_code" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('employee_code') }">
                                    <has-error :form="form" field="employee_code"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Work Address </label>
                                    <input v-model="form.work_address" type="text" name="work_address" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('work_address') }">
                                    <has-error :form="form" field="work_address"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> City </label>
                                    <select v-model="form.city_id" data-live-search="true" name="city_id" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                        <option value="" selected>Select City</option>
                                        <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="city_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group dropdown">
                                    <label class="label block-label"> Branch </label>
                                    <a class="form-control drop-value-changer-branch" data-toggle="dropdown" href="javascript:void(0)" name="branch_id" :class="{ 'is-invalid': form.errors.has('branch_id') }">
                                        {{ getBranchName(form.branch_id) }} <span class="caret"></span>
                                    </a>
                                    <has-error :form="form" field="branch_id"></has-error>
                                    <div class="dropdown-menu add-category-dropdown">
                                        <ul class="list">
                                            <li class="catory-value" v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id" @click="getBranchID(branch.id)"><a class="dropdown-link" href="javascript:void(0)"> {{ branch.name }} </a></li>
                                        </ul>
                                        <div class="add-branch">
                                            <button type="button" name="button" data-toggle="modal" data-target="#branchModal" class="dropdown-link btn btn-primary">
                                                <span class="fa fa-plus"></span>Add Branch
                                                <input type="hidden" id="branch_id" value="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group dropdown">
                                    <label class="label block-label"> Department </label>
                                    <a class="form-control drop-value-changer-department" data-toggle="dropdown" href="javascript:void(0)" name="department_id" :class="{ 'is-invalid': form.errors.has('department_id') }">
                                        {{ getDepartmentName(form.department_id) }} <span class="caret"></span>
                                    </a>
                                    <has-error :form="form" field="department_id"></has-error>
                                    <div class="dropdown-menu add-category-dropdown">
                                        <ul class="list">
                                            <li class="catory-value" v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id" @click="getDepartmentID(department.id)">
                                                <a class="dropdown-link" href="javascript:void(0)"> {{ department.name }} </a>
                                            </li>
                                        </ul>
                                        <div class="add-department">
                                            <button type="button" name="button" data-toggle="modal" data-target="#departmentModal" class="dropdown-link btn btn-primary">
                                                <span class="fa fa-plus"></span>Add Department
                                                <input type="hidden" id="department_id" value="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group dropdown">
                                    <label class="label block-label"> Designation </label>
                                    <a class="form-control drop-value-changer-designation" data-toggle="dropdown" href="javascript:void(0)" name="designation_id" :class="{ 'is-invalid': form.errors.has('designation_id') }">
                                        {{ getDesignationName(form.designation_id) }} <span class="caret"></span>
                                    </a>
                                    <has-error :form="form" field="designation_id"></has-error>
                                    <div class="dropdown-menu add-category-dropdown">
                                        <ul class="list">
                                            <li class="catory-value" v-for="designation in designations" v-bind:value="designation.id" v-bind:key="designation.id" @click="getDesignationID(designation.id)">
                                                <a class="dropdown-link" href="javascript:void(0)"> {{ designation.name }} </a>
                                            </li>
                                        </ul>
                                        <div class="add-designation">
                                            <button type="button" name="button" data-toggle="modal" data-target="#designationModal" class="dropdown-link btn btn-primary">
                                                <span class="fa fa-plus"></span>Add Designation
                                                <input type="hidden" id="designation_id" value="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Report to </label>
                                    <select v-model="form.manager_id" data-live-search="true" name="manager_id" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('manager_id') }" v-if="managers != null">
                                        <option value="" selected>Select Manager</option>
                                        <option v-for="manager in managers" v-bind:value="manager.id" v-bind:key="manager.id">
                                            {{ manager.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="manager_id"></has-error>
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Report To </label>
                                    <select v-model="form.report_to_user" data-live-search="true" name="report_to_user" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('report_to_user') }" >
                                        <option value="" selected>Select User</option>
                                        <option v-for="report_to_user in report_to_users" v-bind:value="report_to_user.id" v-bind:key="report_to_user.id">
                                            {{ report_to_user.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="report_to_user"></has-error>
                                </div>
                            </div> -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> PMS Role </label>
                                    <select v-model="form.pms_role" name="pms_role" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('pms_role') }" >
                                        <option value="EMPLOYEE">Employee</option>
                                        <option value="REPORTING_MANAGER">Reporting Manager</option>
                                        <option value="HR">HR</option>
                                    </select>
                                    <has-error :form="form" field="pms_role"></has-error>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null && designations == null && branches == null && cities == null && departments == null && managers == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    email : '',
                    gross_salary : '',
                    employee_type : '',
                    employee_code : '',
                    work_address : '',
                    designation_id : '',
                    city_id : '',
                    branch_id : '',
                    department_id : '',
                    manager_id : '',
                    hire_date : new Date(),
                    id : this.$route.params.id,
                    // report_to_user : '',
                    pms_role : 'EMPLOYEE',
                }),
                branchForm: new Form({
                    name : ''
                }),
                designationForm: new Form({
                    name : '',
                    department_id : '',
                    designation_description : '',
                    // defaultDesignations_id:'',
                }),
                departmentForm: new Form({
                    name : '',
                    department_code : '',
                }),
                cities : null,
                branches: null,
                managers: null,
                crud_employee: null,
                departments: null,
                designations : null,
                // report_to_users: null,
                defaultDesignations:{}
            }
        },
        methods: {
            getBranchName(branchId){
                let branchArray = this.branches;
                var data = this.$global.checkIdExist(branchId, branchArray);
                if(data !== undefined){
                    return data.name;
                }else{
                    return 'Select Branch';
                }
            },
            getBranchID(id){
                this.form.branch_id = id;
            },
            addBranch(){
                this.form.branch_id = '';
                this.$Progress.start();
                this.branchForm.post('/api/addBranch')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Branch added successfully');
                        $("#branchModal").modal("hide");
                        this.branchForm.name = '';
                        this.getAddEmployeeBasicDetailData();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getDepartmentName(departmentId){
                let departmentArray = this.departments;
                var data = this.$global.checkIdExist(departmentId, departmentArray);
                if(data !== undefined){
                    return data.name;
                }else{
                    return 'Select Department';
                }
            },
            getDepartmentID(id){
                this.form.department_id = id;

                this.designations = [];
                // this.report_to_users = [];
                this.form.designation_id = '';
                // this.form.report_to_user = '';

                this.$Progress.start();
                axios.post('/api/getDepartmentsById', {department_id: id})
                .then(res => {
                    if(res.status == 200){
                        this.designations = res.data.designations;
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                    this.$Progress.finish();
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getDesignationID(id){
                this.form.designation_id = id;
                $(this.$el).find('.selectpicker').selectpicker('refresh');

                // this.report_to_users = [];
                // this.form.report_to_user = '';

                // this.$Progress.start();
                // axios.post('/api/getReportToUsers', 
                //     {
                //         department_id: this.form.department_id,
                //         designation_id: this.form.designation_id,
                //     }
                // )
                // .then(res => {
                // //     this.report_to_users = res.data.report_to_users;
                //     this.$Progress.finish();
                // })
                // .then(res=>{
                // })
                // .catch(err => {
                //     this.$Progress.fail();
                //     this.showAlertBox('error','Error to load data');
                // });
            },
            addDepartment(){
                this.form.department_id = '';
                this.$Progress.start();
                this.departmentForm.post('/api/addDepartment')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Department added successfully');
                        $("#departmentModal").modal("hide");
                        this.departmentForm.name = '';
                        this.departmentForm.department_code = '';
                        this.getAddEmployeeBasicDetailData();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getDesignationName(designationId){
                let designationArray = this.designations;
                var data = this.$global.checkIdExist(designationId, designationArray);
                if(data !== undefined){
                    return data.name;
                }else{
                    return 'Select Designation';
                }
            },
            addDesignation(){

                // quick fix start
                let selectElm = $(this.$el).find('.selectpicker');

                if(selectElm.parent())
                {
                    selectElm.parent().removeClass('is-invalid');
                }
                // quick fix end

                this.form.designation_id = '';
                this.$Progress.start();
                this.designationForm.post('/api/addDesignation')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Designation added successfully');
                        $("#designationModal").modal("hide");
                        this.designationForm.name = '';
                        this.designationForm.department_id = '';
                        this.designationForm.designation_description = '';
                        this.getAddEmployeeBasicDetailData();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            addEmployeeBasicDetail() {
                if(this.form.department_id === "" || this.form.designation_id === "" || this.form.manager_id === ""){
                    swal.fire({
                        title: 'Need your attention',
                        text: "Come back later and fill the remaining information for better analytics!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Proceed',
                        cancelButtonText: 'No, cancel!',
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            this.submitEmployeeData();
                        } else if (result.dismiss === Swal.DismissReason.cancel){
                            this.$Progress.fail();
                            swal.fire(
                                'Cancelled',
                                'Your decision has been cancelled',
                                'error'
                            )
                        }
                    })
                }else{
                    this.submitEmployeeData();
                }
            },
            getAddEmployeeBasicDetailData(){
                
                this.$Progress.start();
                axios.post('/api/addEmployeeBasicDetailData', {department_id: this.form.department_id})
                .then(res => {
                    if(res.status == 200){
                        this.designations = res.data.designations;
                        this.cities = res.data.cities;
                        this.branches = res.data.branches;
                        this.departments = res.data.departments;
                        this.managers = res.data.managers;
                        // this.defaultDesignations=res.data.defaultDesignations;
                        this.$Progress.finish();
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.form.email = (res.data.user.email==null) ? '' : res.data.user.email;
                                this.form.gross_salary = (res.data.user.net_salary==null) ? '' : res.data.user.net_salary;
                                this.form.employee_type = (res.data.user.employment_status==null) ? '' : res.data.user.employment_status;
                                this.form.employee_code = (res.data.user.employeeCode==null) ? '' : res.data.user.employeeCode;
                                this.form.work_address = (res.data.user.work_address==null) ? '' : res.data.user.work_address;
                                this.form.designation_id = (res.data.user.designation_id==null) ? '' : res.data.user.designation_id;
                                this.form.department_id = (res.data.user.department_id==null) ? '' : res.data.user.department_id;
                                // this.form.report_to_user = (res.data.user.report_to==null) ? '' : res.data.user.report_to;
                                // this.report_to_users = (res.data.report_to_users==null) ? null : res.data.report_to_users;
                                this.form.pms_role = (res.data.user.pms_role==null) ? 'EMPLOYEE' : res.data.user.pms_role;
                                this.form.city_id = (res.data.user.city_id==null) ? '' : res.data.user.city_id;
                                this.form.branch_id = (res.data.user.branch_id==null) ? '' : res.data.user.branch_id;
                                this.form.manager_id = (res.data.user.manager_id==null) ? '' : res.data.user.manager_id;
                                this.form.hire_date = (res.data.user.joining_date==null) ? '' : res.data.user.joining_date;
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                        this.getAddEmployeeBasicDetailData();
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },


            submitEmployeeData(){
                this.$Progress.start();
                this.form.post('/api/addEmployeeBasicDetail/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == 411){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.message);
                        }else{
                            this.$Progress.finish();
                            this.showToastBox('success', 'Employee job details added successfully');
                            this.$router.push('/addEmployeeTaxDetail/'+res.data.data.id);
                        }
                    }else{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');

                });
            }
        },
        mounted() {
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    this.getEmployeeData();
                }
            });
        }
    }
</script>
